<div style="margin: 10px 10px 10px 0px;">
  <h1>SSH</h1>
  <form [formGroup]="SettingsForm" (ngSubmit)="applyTempChanges()">
    <div class="mb-3 row">
      <label for="name" class="col-lg-2 col-form-label">Name:</label>
      <div class="col-lg-4">
        <input id="name" type="text" class="form-control" [ngClass]="{'is-invalid':!Name.valid}" [formControl]="Name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="IsDefault" [ngClass]="{'is-invalid': !IsDefault.valid}" />
        <span class="uv-checkbox-label">Default</span>
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="username" class="col-lg-2 col-form-label">User Name:</label>
      <div class="col-lg-4">
        <input id="username" type="text" class="form-control" [ngClass]="{'is-invalid':!Username.valid}" [formControl]="Username" />
      </div>
    </div>
    @if (Username.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">User Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="password" class="col-lg-2 col-form-label">Password:</label>
      <div class="col-lg-4">
        <input id="password" [type]="PasswordInputType" class="form-control"
          [ngClass]="{'is-invalid':SettingsForm.hasError('passwordsEqual')}" [formControl]="Password"
          (keydown)="onPasswordKeyDownHandler($event, 'Password')" />
        </div>
        <label for="confirmPassword" class="col-lg-2 col-form-label">Confirm Password:</label>
        <div class="col-lg-4">
          <input id="confirmPassword" [type]="PasswordInputType" class="form-control"
            [ngClass]="{'is-invalid':SettingsForm.hasError('passwordsEqual')}" [formControl]="PasswordConfirm"
            (keydown)="onPasswordKeyDownHandler($event, 'Password')" />
          </div>
        </div>
        @if (SettingsForm.hasError('passwordsEqual')) {
          <div class="mb-3 row">
            <div class="col-lg-6 alert alert-danger error-message">Confirm Password must be the same as Password</div>
          </div>
        }
        <div class="mb-3 row">
          <label for="enablePassword" class="col-lg-2 col-form-label">Enable Password:</label>
          <div class="col-lg-4">
            <input id="enablePassword" [type]="PasswordInputType" class="form-control"
              [ngClass]="{'is-invalid':SettingsForm.hasError('enablePasswordsEqual')}" [formControl]="EnablePassword"
              (keydown)="onPasswordKeyDownHandler($event, 'EnablePassword')" />
            </div>
            <label for="confirmEnablePassword" class="col-lg-2 col-form-label">Confirm Enable Password:</label>
            <div class="col-lg-4">
              <input id="confirmEnablePassword" [type]="PasswordInputType" class="form-control"
                [ngClass]="{'is-invalid':SettingsForm.hasError('enablePasswordsEqual')}" [formControl]="EnablePasswordConfirm"
                (keydown)="onPasswordKeyDownHandler($event, 'EnablePassword')" />
              </div>
            </div>
            @if (SettingsForm.hasError('enablePasswordsEqual')) {
              <div class="mb-3 row">
                <div class="col-lg-6 alert alert-danger error-message">Confirm Enable Password must be the same as Enable Password</div>
              </div>
            }
            <div class="mb-3 row" style="margin-bottom: 20px;">
              <label for="sshShowChars" class="col-lg-2 col-form-label">&nbsp;</label>
              <div class="col-lg-10">
                <input id="sshShowChars" type="checkbox" [formControl]="ShowChars"
                  (change)="ToggleShowChars()" [ngClass]="{'is-invalid':!ShowChars.valid}" />
                  <span class="uv-checkbox-label">Show Chars</span>
                </div>
              </div>
              <div class="mb-3 row">
                <label for="ipscope" class="col-lg-2 col-form-label">IP Scope:</label>
                <div class="col-lg-4">
                  <textarea id="ipscope" rows="5" cols="50" class="form-control" [formControl]="IpScope"
                  [ngClass]="{'is-invalid': !IpScope.valid}"></textarea>
                </div>
              </div>
              <fieldset>
                <legend>Advanced</legend>
                <div class="mb-3 row">
                  <label for="port" class="col-lg-2 col-form-label">Port:</label>
                  <div class="col-lg-2">
                    <input id="port" type="number" class="form-control" [ngClass]="{'is-invalid':!Port.valid}" [formControl]="Port" />
                  </div>
                  <label for="loginTimeout" class="col-lg-2 col-form-label">Login Timeout (in milliseconds):</label>
                  <div class="col-lg-2">
                    <input id="loginTimeout" type="number" class="form-control" [ngClass]="{'is-invalid':!LoginTimeout.valid}" [formControl]="LoginTimeout" />
                  </div>
                </div>
                @if (Port.hasError('required') || Port.hasError('minValue') || Port.hasError('maxValue') || LoginTimeout.hasError('required') || LoginTimeout.hasError('minValue') || LoginTimeout.hasError('maxValue')) {
                  <div class="mb-3 row">
                    @if (Port.hasError('required')) {
                      <div class="col-lg-4 alert alert-danger error-message">Port is required</div>
                    }
                    @if (Port.hasError('minValue') || Port.hasError('maxValue')) {
                      <div class="col-lg-4 alert alert-danger error-message">Port must be in the range 1 - 65535</div>
                    }
                    @if (LoginTimeout.hasError('required')) {
                      <div class="col-lg-4 alert alert-danger error-message">Login Timeout is required</div>
                    }
                    @if (LoginTimeout.hasError('minValue') || LoginTimeout.hasError('maxValue')) {
                      <div class="col-lg-4 alert alert-danger error-message">Login Timeout must be in the range 0 - 120000</div>
                    }
                  </div>
                }
                <div class="mb-3 row">
                  <label for="readTimeout" class="col-lg-2 col-form-label">Read Timeout (in milliseconds):</label>
                  <div class="col-lg-2">
                    <input id="readTimeout" type="number" class="form-control" [ngClass]="{'is-invalid':!ReadTimeout.valid}" [formControl]="ReadTimeout" />
                  </div>
                  <label for="readPause" class="col-lg-2 col-form-label">Read Pause (in milliseconds):</label>
                  <div class="col-lg-2">
                    <input id="readPause" type="number" class="form-control" [ngClass]="{'is-invalid':!ReadPause.valid}" [formControl]="ReadPause" />
                  </div>
                </div>
                @if (ReadTimeout.hasError('required') || ReadTimeout.hasError('minValue') || ReadTimeout.hasError('maxValue') || ReadPause.hasError('required') || ReadPause.hasError('minValue') || ReadPause.hasError('maxValue')) {
                  <div class="mb-3 row">
                    @if (ReadTimeout.hasError('required')) {
                      <div class="col-lg-4 alert alert-danger error-message">Read Timeout is required</div>
                    }
                    @if (ReadTimeout.hasError('minValue') || ReadTimeout.hasError('maxValue')) {
                      <div class="col-lg-4 alert alert-danger error-message">Read Timeout must be in the range 0 - 120000</div>
                    }
                    @if (ReadPause.hasError('required')) {
                      <div class="col-lg-4 alert alert-danger error-message">Read Pause is required</div>
                    }
                    @if (ReadPause.hasError('minValue') || ReadPause.hasError('maxValue')) {
                      <div class="col-lg-4 alert alert-danger error-message">Read Pause must be in the range 0 - 120000</div>
                    }
                  </div>
                }
              </fieldset>

              <button type="submit" pButton [disabled]="!SettingsForm.valid || SettingsForm.pristine" label="Apply"></button>
            </form>
          </div>
